import { createSlice } from "@reduxjs/toolkit";
import { puertosxApiSlice } from "./puertosxApiSlice";

const puertosxSlice = createSlice({
  name: "puertosx",
  initialState: {
    // { PUERIDXX: PUEDESCX } de los puertos consultados
    nombresPorCodigo: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      puertosxApiSlice.endpoints.getPuertoByPais.matchFulfilled,
      (state, action) => {
        (action.payload?.data ?? []).forEach((puerto) => {
          if (puerto?.id !== null && puerto?.id !== undefined) {
            state.nombresPorCodigo[String(puerto.id).trim()] = puerto.label;
          }
        });
      }
    );
  },
});

export default puertosxSlice.reducer;

export const getNombresPuertos = (state) => {
  return state.puertosx.nombresPorCodigo;
};
